import InitialRequest from './InitialRequest';

export default InitialRequest;



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/InitialRequest/index.jsx